export default "__VITE_ASSET__Bkix$SEH__"